export const APP_NAME = 'portfolio_listing_perseus';
